import Code from 'eflex/models/code';

export default class RepairCode extends Code {}
